import { keysToCamel } from '~/utility/toCamel'
import { langFallback$Fetch } from '../../../lang/utils/langfetch'
import { MeInfo } from '../types'

export async function getMeInfo(fetchOptions?) {
  return keysToCamel(
    await langFallback$Fetch<MeInfo>('en-gb', '/me-info/', fetchOptions),
  )
}
